import React, { useContext, useEffect } from "react"
import { Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { programmeContext } from "../../../contexts"
import TemoinNavigationContent from "./TemoinNavigationContent"

const Redirect = ({ where }) => {

  const navigate = useNavigate()

  useEffect(() => {
    navigate(where)
  }, [])
}

const TemoinNavigation = ({currentFloor, setCurrentFloor, interactivTemoin, setInteractivTemoin}) => {
  const { search } = useLocation()
  const [searchParams] = useSearchParams()
  const programmeDatas = useContext(programmeContext)
  const temoinsDatas = programmeDatas.pagesDetails.interieurs2.temoins

  return (
    <div>
      <Routes>
        <Route
          path=""
          element={
            <Redirect
              where={`/${programmeDatas.urlName}/interieurs/temoins/${
                temoinsDatas[0].urlName
              }${search}`}
            />
          }
        />
        {/* {!searchParams.get("isolate") && */}
          <Route path=":currentInt" element={
            <TemoinNavigationContent 
              currentFloor = {currentFloor} 
              setCurrentFloor = {setCurrentFloor} 
              interactivTemoin = {interactivTemoin} 
              setInteractivTemoin = {setInteractivTemoin}
            />} 
          />
        {/* } */}
      </Routes>
    </div>
  )
}

export default TemoinNavigation
